import React from 'react';
import { Box, Button, Paper } from '@mui/material';
import {
  Add as AddIcon,
  Search as SearchIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';

interface QuickActionsProps {
  onAddAppointment: () => void;
  onQuickSearch: () => void;
  onRefresh: () => void;
}

export const QuickActions: React.FC<QuickActionsProps> = ({
  onAddAppointment,
  onQuickSearch,
  onRefresh
}) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Box display="flex" gap={2} flexWrap="wrap">
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={onAddAppointment}
        >
          Adauga programare
        </Button>

        <Button
          variant="outlined"
          color="primary"
          startIcon={<SearchIcon />}
          onClick={onQuickSearch}
        >
          Cautare rapida
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
        >
          Actualizeaza
        </Button>
      </Box>
    </Paper>
  );
};

